// extracted by mini-css-extract-plugin
module.exports = {"copy-to-clipboard":"links_copy-to-clipboard__1-mQj"};